module.exports = __webpack_public_path__ + "img/zjnb.01cd45c3.png";